import { mapState, mapGetters, mapActions } from 'vuex'
import Loading from '@/components/Core/Loading'
import Constants from '@/utils/Constants'
import Utility from '@/utils/Utility'

export default {
  name: 'ServiceAttribute',
  components: {
    Loading
  },
  metaInfo () {
    let title = this.categoryName + '管理 | ' + Constants.SiteInfo.title
    this.setMeta({ title: title })
    return this.getMeta
  },
  props: {
    serviceId: String
  },
  data () {
    return {
      loading: true,
      processing: false,
      
      // テーブルオプション
      tableColumns: [
        'attributeTypeId',
        'attributeTypeName',
        'attributeTypeCode',
        'attributeCounts',
        'deliveryFlg',
        'attributeTypeStatus',
        'detailButton'
      ],
      tableData: [],
      tableOptions: {
        headings: {
          attributeTypeId: '属性種別ID',
          attributeTypeName: '属性種別名',
          attributeTypeCode: '属性種別コード',
          attributeCounts: '属性数',
          deliveryFlg: '配信設定',
          attributeTypeStatus: 'ステータス',
          detailButton: ''
        },
        columnsClasses: {
          attributeTypeId: 'wp-5',
          attributeTypeName: '',
          attributeTypeCode: '',
          attributeCounts: '',
          deliveryFlg: '',
          attributeTypeStatus: '',
          detailButton: 'wp-5 has-button'
        },
        sortable: [
          'attributeTypeId',
          'attributeTypeName',
          'attributeTypeCode',
          'attributeCounts',
          'deliveryFlg',
          'attributeTypeStatus'
        ],
        filterable: [],
        texts: Constants.TableOptions.getTexts(this.categoryName),
        // perPage: Constants.TableOptions.perPage.view,
        perPage: Constants.TablePerPageInitial,
        perPageValues: Constants.TableOptions.perPageValues,
        pagination: Constants.TableOptions.pagination
      },

      // 絞込み
      activeFilters: false,
      filterPerPage: Constants.TablePerPageInitial
    }
  },
  // beforeMount () {
  //   if (this.getPermission('Member')) return
  //   this.$router.push({name: 'Home'})
  // },
  mounted () {
    this.$set(this.tableOptions, 'texts', Constants.TableOptions.getTexts(this.categoryName))

    this.init()
  },
  computed: {
    ...mapState({
      categoryName: state => state.serviceAttribute.categoryName,
      serviceName: state => state.serviceAttribute.serviceName,
      // model
      attributeTypeModel: state => state.serviceAttribute.attributeTypeModel
    }),
    ...mapGetters({
      getMeta: 'meta/get',
      permittedView: 'permission/permittedView',
      isSmartPhone: 'core/isSmartPhone'
    }),

    // list
    // deliverySettingList () {
    //   return Constants.Service.AttributeDeliverySetting.sort(Utility.sortByKey('index', false))
    // },
    tablePerPageList () {
      let list = []
      Constants.TablePerPage.forEach(item => list.push({
        value: item,
        label: item
      }))
      return list
    },
    showFilters () {
      return !this.isSmartPhone ||
        this.activeFilters
    },
  },
  methods: {
    ...mapActions({
      setMeta: 'meta/set',
      showError: 'error/show',
      loadModel: 'serviceAttribute/loadModel'
    }),

    init () {
      this.loading = true

      //
      let attributeTypeParams = {
        serviceUuid: this.serviceId
      }

      // データ読出し
      this.loadModel({
        attributeTypeParams: attributeTypeParams
      })
        // eslint-disable-next-line
        .then(res => {
          this.loading = false
          this.tableData = $.extend(true, [], this.attributeTypeModel)
        })
        .catch(error => {
          this.showError(error || null)
        })
    },
    getViewData (props) {
      let key = props.column
      let value = props.row[key]

      switch (key) {
        case 'attributeTypeCode':
          return value || '未設定'
        case 'deliveryFlg':
          return Utility.getConstantsLabel(['Service', 'AttributeDeliverySetting'], value)
        case 'attributeTypeStatus':
          return Utility.getConstantsLabel(['Status'], value)
      }
      return value
    },
    changePage () {
      // console.log(this.$refs.table.page)
    },

    // 絞り込み
    toggleFilters () {
      this.activeFilters = !this.activeFilters
    },
    changePerPage () {
      this.$refs.table.setLimit(this.filterPerPage)
    },

    detailItem (props) {
      this.$router.push({
        name: 'ServiceAttributeDetail',
        params: {
          serviceId: this.serviceId,
          attributeTypeId: String(props.row.attributeTypeUUID)
        }
      })
    }
  }
}